import { gql, useMutation } from "@apollo/client";

const CREATE_UPDATE_EXCLUSIONS = gql`
  mutation createOrUpdateMemberVenueExclusion(
    $memberVenueExclusions: [memberVenueExclusionInputType]!
    $partnerId: ID!
  ) {
    createOrUpdateMemberVenueExclusion(
      memberVenueExclusions: $memberVenueExclusions
      partnerId: $partnerId
    ) {
      id
    }
  }
`;

const DELETE_EXCLUSION = gql`
  mutation deleteMemberVenueExclusion($id: ID!, $partnerId: ID!) {
    deleteMemberVenueExclusion(id: $id, partnerId: $partnerId) {
      id
    }
  }
`;

const useVenueExclusions = () => {
  const refetchQueries = [
    "getVenues",
    "getVenueOwnerExclusionsAndTags",
    "getMemberExclusions"
  ];

  const [createOrUpdateMemberVenueExclusion] = useMutation(
    CREATE_UPDATE_EXCLUSIONS,
    {
      refetchQueries
    }
  );

  const [deleteMemberVenueExclusion] = useMutation(DELETE_EXCLUSION, {
    refetchQueries
  });

  return {
    createOrUpdateMemberVenueExclusion,
    deleteMemberVenueExclusion
  };
};

export default useVenueExclusions;
